// Keep route identity small: this module is part of the shared app shell.
export const DSCR_HUB_PATH = '/mortgage-rates/dscr';
export const DSCR_RELEASE_APPROVED = true;
export const DSCR_STATES = ['california', 'ohio', 'florida', 'texas', 'tennessee'] as const;
export type DscrStateSlug = typeof DSCR_STATES[number];
export type DscrSourcePage = 'dscr' | DscrStateSlug;
export const DSCR_STATE_CODES: Record<DscrStateSlug, string> = {
  california: 'CA', ohio: 'OH', florida: 'FL', texas: 'TX', tennessee: 'TN',
};

// Editing these gates is a publication decision. A source implementation and
// an image's metadata are neither service authorization nor release approval.
export const DSCR_PUBLICATION = {
  genericContentApproved: true,
  states: Object.fromEntries(DSCR_STATES.map(state => [state, {
    serviceApproved: true, contentApproved: true,
    // Full release and license verification is recorded in the portal implementation ledger.
    evidence: 'dscr-release-2026-10-28' as string | null,
  }])) as Record<DscrStateSlug, { serviceApproved: boolean; contentApproved: boolean; evidence: string | null }>,
};

export function isDscrPublished(slug?: DscrStateSlug): boolean {
  if (!DSCR_RELEASE_APPROVED || !DSCR_PUBLICATION.genericContentApproved) return false;
  if (!slug) return true;
  const state = DSCR_PUBLICATION.states[slug];
  return state.serviceApproved && state.contentApproved && Boolean(state.evidence);
}

export function isDscrPath(path: string): boolean {
  return path === DSCR_HUB_PATH || path.startsWith(`${DSCR_HUB_PATH}/`);
}
